import PropTypes from "prop-types";
import { Notification } from "@mantine/core";

export default function CustomInlineBanner({ styles, children, ...props }) {
  return (
    <Notification withCloseButton={false} styles={styles} {...props}>
      {children}
    </Notification>
  );
}

CustomInlineBanner.propTypes = {
  styles: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
